import React from "react";
import { useAdminApi } from "../../AdminApiContext";

const TariffList = ({ onEdit }) => {
  const { tariffs, loading, error, deleteTariff } = useAdminApi();

      const handleDelete = async (id, name) => {
    const confirmed = window.confirm(`Удалить тариф "${name}"?`);
    if (confirmed) {
      await deleteTariff(id);
    }
  };

  if (loading) return <p>Загрузка тарифов…</p>;
  if (error)   return <p style={{color:"red"}}>{error}</p>;

  return (
    <>
      {tariffs.length === 0 ? "Нет тарифов" : (
          <table
            border="1"
            cellPadding="6"
            style={{
              width: "100%",
              tableLayout: "fixed", // фиксированная ширина колонок
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                <th style={{ width: "50px", wordWrap: "break-word" }}>ID</th>
                <th style={{ width: "120px", wordWrap: "break-word" }}>Имя</th>
                <th style={{ width: "80px" }}>Цена/день</th>
                <th style={{ width: "80px" }}>Цена/мес.</th>
                <th style={{ width: "200px", wordWrap: "break-word" }}>Включённые сервисы</th>
                <th style={{ width: "250px", wordWrap: "break-word" }}>Описание</th>
                <th style={{ width: "80px" }}>Рекомендуемый</th>
                <th style={{ width: "80px" }}>порядок выдачи</th>               
                <th style={{ width: "80px" }}>Видно в прайсе</th>
                <th style={{ width: "80px" }}></th>
              </tr>
            </thead>
            <tbody>
              {tariffs.map((t) => (
                <tr key={t.id}>
                  <td>{t.id}</td>
                  <td>{t.name}</td>
                  <td>{t.daily_price}</td>
                  <td>{t.month_price}</td>
                  <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {t.included_services
                      .map(
                        (i) =>
                          `{id:${i.service_id}, ${i.name}, ${i.technical_name}:${i.value}}`
                      )
                      .join(", ")}
                  </td>
                  <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {t.description}
                  </td>

                  <td>{t.recomend ? "✓" : "—"}</td>
                  <td>{t.order}</td>
                  <td>{t.active ? "Да" : "—"}</td>

                  <td>
                    <button onClick={() => onEdit(t)}>✏️</button>
                    <button
                      onClick={() => handleDelete(t.id, t.name)}
                      style={{ color: "red" }}
                    >
                      🗑️
                    </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default TariffList;
